import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const downloadContentForManualMatch = (payload) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const downloadContentForManualMatchSuccess = (payload) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const downloadContentForManualMatchFailure = (payload) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_FAILURE,
    payload,
});

export const downloadContentForManualMatchReset = () => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_RESET,
});

// Action creator for resetting all OTP generation reducer
export const downloadContentForManualMatchResetAll = () => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_RESET_ALL,
});
